import React, { useEffect } from "react";
import { Card, Row, Col, Select, Input, InputNumber, Button, Typography, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { setFormField, resetShippingForm } from "./shippingSlice";
import { saveShipping } from "./shippingThunk";

const { Title, Text } = Typography;

const Shipping = () => {
    const dispatch = useDispatch();
    const authInfo = useSelector(selectAuthInfo);
    const {
        shipping_type,
        sscc_code,
        sender_gln,
        receiver_gln,
        sender_gcp_length,
        receiver_gcp_length,
        saving,
    } = useSelector((s) => s.tatmeenShipping);

    useEffect(() => {
        if (!sender_gln && authInfo?.branch_gln_no) {
            dispatch(setFormField({ field: "sender_gln", value: authInfo.branch_gln_no }));
        }
    }, [authInfo]);

    const setField = (field) => (value) =>
        dispatch(setFormField({ field, value: value?.target ? value.target.value : value }));

    const handleSave = async () => {
        if (!sscc_code || !sscc_code.trim()) {
            message.error("SSCC Code is required");
            return;
        }
        if (!sender_gln || !sender_gln.trim()) {
            message.error("Sender GLN is required");
            return;
        }
        if (!receiver_gln || !receiver_gln.trim()) {
            message.error("Receiver GLN is required");
            return;
        }

        const result = await dispatch(
            saveShipping({
                shipping_type,
                sscc_code,
                sender_gln,
                receiver_gln,
                sender_gcp_length,
                receiver_gcp_length,
            })
        );

        if (saveShipping.fulfilled.match(result)) {
            message.success(result.payload?.message || "Shipping record saved successfully");
            dispatch(resetShippingForm());
        } else {
            message.error(result.payload || "Failed to save shipping record");
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <Title level={3} style={{ margin: 0, marginBottom: 16 }}>
                Shipping
            </Title>

            <Card bordered={false} style={{ borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,.08)", maxWidth: 720 }}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Text strong>Shipping Type</Text>
                        <Select
                            style={{ width: "100%", marginTop: 5 }}
                            value={shipping_type}
                            onChange={setField("shipping_type")}
                            options={[
                                { label: "Sales", value: "sales" },
                                { label: "Purchase Return", value: "purchase_return" },
                            ]}
                        />
                    </Col>

                    <Col span={24}>
                        <Text strong>SSCC Code</Text>
                        <Input
                            style={{ marginTop: 5 }}
                            placeholder="Enter SSCC Code"
                            value={sscc_code}
                            onChange={setField("sscc_code")}
                        />
                    </Col>

                    <Col xs={24} md={12}>
                        <Text strong>Sender GLN (our company)</Text>
                        <Input
                            style={{ marginTop: 5 }}
                            placeholder="Enter Sender GLN"
                            value={sender_gln}
                            onChange={setField("sender_gln")}
                        />
                    </Col>

                    <Col xs={24} md={12}>
                        <Text strong>Sender Company Prefix Length</Text>
                        <InputNumber
                            min={6}
                            max={12}
                            precision={0}
                            style={{ width: "100%", marginTop: 5 }}
                            value={sender_gcp_length}
                            onChange={setField("sender_gcp_length")}
                        />
                    </Col>

                    <Col xs={24} md={12}>
                        <Text strong>Destination GLN</Text>
                        <Input
                            style={{ marginTop: 5 }}
                            placeholder="Enter Destination GLN"
                            value={receiver_gln}
                            onChange={setField("receiver_gln")}
                        />
                    </Col>

                    <Col xs={24} md={12}>
                        <Text strong>Destination Company Prefix Length</Text>
                        <InputNumber
                            min={6}
                            max={12}
                            precision={0}
                            style={{ width: "100%", marginTop: 5 }}
                            value={receiver_gcp_length}
                            onChange={setField("receiver_gcp_length")}
                        />
                    </Col>

                    <Col span={24}>
                        <Button
                            type="primary"
                            icon={<SaveOutlined />}
                            loading={saving}
                            onClick={handleSave}
                        >
                            Save Shipping
                        </Button>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default Shipping;
